import React, {Component} from 'react'
import CustomSortBy from '../filters/sort-by'
import Stats from '../filters/stats'
import Banner from '../../../banner'
import ProductResults from '../../shared/product-results'
import {connectCurrentRefinements, ScrollTo} from 'react-instantsearch-dom'
import FilterFilters from '../filters/filter-filters'
import {DetermineAlgoliaCountryTitle} from '../../config'

class CollectionResults extends Component {
    constructor(props) {
        super(props)

        this.openFilters = this.openFilters.bind(this)
        this.countryString = DetermineAlgoliaCountryTitle(this.props.country)
        this.algoliaConfig = this.props.algoliaConfig
    }

    openFilters() {
        const element = document.getElementById(`sidebar-content`)
        if (element.classList.contains(`sidebar-mobile-view`)) {
            element.classList.remove(`sidebar-mobile-view`)
        } else {
            element.classList.add(`sidebar-mobile-view`)
        }
    }

    render() {
        const {
            changeResultsIndex,
            collection,
            items,
            refinementCount,
            resultsIndex,
            activeAlgoliaIndex,
        } = this.props

        const locationIsFiltered = items.filter(
            item => item.id === `named_tags.locfilter`
        ).length

        return (
            <ScrollTo>
                <div className="AlgoliaResults">
                <div className="stats flex padding-top-2x">
                    <Stats hitsLeft={false}/>
                    <div className="alwaysShow">
                        <CustomSortBy
                            changeResultsIndex={changeResultsIndex}
                            defaultRefinement={activeAlgoliaIndex}
                            items={this.algoliaConfig.sortOptions}
                        />
                    </div>
                    <div className="small-show" onClick={e => this.openFilters()}>
                        <div className="filter-icon">
                            <p className="padding-right-1x">Filter</p>
                        </div>
                    </div>
                </div>
                {locationIsFiltered ? (
                    <Banner
                        text={
                            <React.Fragment>
                                <h6>{`We ship to anywhere in ${this.countryString}`}</h6>
                                <p>{`Don't just limit your search to a location, every item we stock can be delivered anywhere in ${this.countryString}.`}</p>
                            </React.Fragment>
                        }
                        actions={
                            <React.Fragment>
                                <a
                                    href="/pages/delivery-returns"
                                    className="button is-small not-button"
                                >
                                    Learn more
                                </a>
                                <FilterFilters
                                    className="button is-small is-border"
                                    text="Browse All Locations"
                                    filter={item => item.id === `named_tags.locfilter`}
                                />
                            </React.Fragment>
                        }
                    />
                ) : null}

                <div className={`product flex flex-column`}>
                    <ProductResults
                        resultsIndex={this.props.resultsIndex}
                        collection={collection}
                    />
                </div>
            </div>
            </ScrollTo>
        )
    }
}

export default connectCurrentRefinements(CollectionResults)
